<!--
/*******************************************************************************
*@ 컴포넌트명   : Common.vue
*@ 컴포넌트설명 : 모든 vue 화면에서 상속받는 컴포넌트
*@ 주의!!      : 해당 파일에서 사용안하고 있어도 상속받은 자식vue에서 사용할 수 있으니 삭제시 주의 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import ContentsHeader from "@/components/page/common/ContentsHeader.vue";

export default {
  components: { ContentsHeader },
  computed: {
    ...mapFields(["pageLoading", "loading", "siteCode", "error", "lang"]),
  },
  methods: {
    ...mapActions("native", ["actGoBackPage"]),
    /**
     * @param {Boolean} isShow 모달 show 여부
     * @param {String} code 오류 코드 (Device > ErrmsgErrcd)
     * @param {String} msg 오류 메시지 (Device > 1순위 : ErrmsgOutptCstzMsgCtnt, 2순위 : TreatDesc)
     */
    setErrorModal(isShow, code, msg) {
      if (isShow) {
        this.$set(this, "error", { active: true, errCode: code, errMsg: msg });
      } else {
        this.$set(this, "error", { active: false, errCode: "", errMsg: "" });
      }
    },
    /**
     * 메인화면으로 이동
     */
    goMain() {
      this.$router.push({ name: "main", params: { siteCode: this.siteCode, lang: this.lang } }); // 메인으로
    },
  },
};
</script>